import React from 'react'
import Select from 'react-select'

const menuPortalStyles = {
  menuPortal: (base) => ({ ...base, zIndex: 10050 }),
}

const OMultiSelect = (props) => {
  const {
    wrapperClassName,
    placeholder,
    value,
    onChange,
    options,
    menuPortalTarget,
    styles: customStyles,
    ...rest
  } = props
  return (
    <div className={wrapperClassName ?? 'relative z-0 mb-6 w-full group'}>
      <Select
        isMulti
        name='referenceLink '
        options={options}
        placeholder={placeholder}
        className='basic-multi-select'
        classNamePrefix='select'
        value={value}
        menuPortalTarget={
          typeof document !== 'undefined'
            ? menuPortalTarget ?? document.body
            : null
        }
        menuPosition='fixed'
        styles={{
          ...menuPortalStyles,
          ...customStyles,
        }}
        onChange={(item) => {
          onChange(item)
        }}
        {...rest}
      />
    </div>
  )
}

export default OMultiSelect
